import { useTenant } from '../../contexts/TenantContext';

export default function AboutPage() {
  const tenant = useTenant();

  return (
    <div
      className="min-h-screen py-12 px-4"
      style={{
        background: tenant.theme.colors.gradients.main,
        fontFamily: tenant.theme.fonts.body.family
      }}
    >
      <div className="max-w-4xl mx-auto">
        <div
          className="p-8 rounded-lg shadow-lg"
          style={{
            background: 'rgba(17, 24, 39, 0.95)',
            border: '1px solid rgba(51, 65, 85, 0.5)'
          }}
        >
          <h1
            className="text-4xl font-bold mb-6"
            style={{
              fontFamily: tenant.theme.fonts.primary.family,
              color: tenant.theme.colors.accent
            }}
          >
            Sobre {tenant.name}
          </h1>

          <div className="space-y-6 text-gray-200 leading-relaxed">
            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                ¿Qué es Neureka?
              </h2>
              <p>
                <strong style={{ color: tenant.theme.colors.accent }}>Neureka</strong> es una plataforma de
                entrenamiento cognitivo diseñada para mejorar la concentración, memoria, razonamiento lógico
                y agilidad mental mediante una colección de juegos de lógica cuidadosamente seleccionados.
              </p>
              <p className="mt-4">
                Inspirados en los clásicos puzzle japoneses como Sudoku, Hitori, Nurikabe y muchos otros,
                hemos creado una experiencia completa de entrenamiento mental adaptada tanto para uso personal
                como profesional.
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                Nuestra Visión
              </h2>
              <p>
                Creemos que el entrenamiento cognitivo debe ser accesible, medible y motivador. Por eso
                ofrecemos:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>17 juegos de lógica diferentes para trabajar distintas áreas cognitivas</li>
                <li>Sistema de seguimiento de progreso personalizado</li>
                <li>Herramientas para profesionales de la salud mental</li>
                <li>Sesiones presenciales y remotas para terapeutas</li>
                <li>Estadísticas detalladas y gráficos de evolución</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                ¿Qué nos hace diferentes?
              </h2>
              <div className="grid md:grid-cols-2 gap-4 mt-4">
                <div
                  className="p-4 rounded-lg"
                  style={{ background: 'rgba(15, 23, 42, 0.8)' }}
                >
                  <h3
                    className="font-semibold mb-2"
                    style={{ color: tenant.theme.colors.accent }}
                  >
                    🎯 Enfoque Profesional
                  </h3>
                  <p className="text-sm">
                    Herramientas diseñadas para psicólogos, terapeutas y profesionales de la salud mental.
                  </p>
                </div>
                <div
                  className="p-4 rounded-lg"
                  style={{ background: 'rgba(15, 23, 42, 0.8)' }}
                >
                  <h3
                    className="font-semibold mb-2"
                    style={{ color: tenant.theme.colors.accent }}
                  >
                    📊 Seguimiento Detallado
                  </h3>
                  <p className="text-sm">
                    Estadísticas completas de rendimiento, tiempo y evolución para cada paciente.
                  </p>
                </div>
                <div
                  className="p-4 rounded-lg"
                  style={{ background: 'rgba(15, 23, 42, 0.8)' }}
                >
                  <h3
                    className="font-semibold mb-2"
                    style={{ color: tenant.theme.colors.accent }}
                  >
                    🎮 Variedad de Juegos
                  </h3>
                  <p className="text-sm">
                    17 juegos diferentes para trabajar memoria, lógica, atención y razonamiento espacial.
                  </p>
                </div>
                <div
                  className="p-4 rounded-lg"
                  style={{ background: 'rgba(15, 23, 42, 0.8)' }}
                >
                  <h3
                    className="font-semibold mb-2"
                    style={{ color: tenant.theme.colors.accent }}
                  >
                    🌐 Sesiones Flexibles
                  </h3>
                  <p className="text-sm">
                    Soporte para sesiones presenciales y remotas con gestión de pacientes.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                Origen de los Juegos
              </h2>
              <p>
                Los juegos de lógica que utilizamos tienen su origen en publicaciones japonesas de puzzle
                y han sido ampliamente estudiados por sus beneficios cognitivos. Cada juego trabaja
                habilidades específicas:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-1 ml-4 text-sm">
                <li><strong>Sudoku</strong> - Razonamiento lógico y paciencia</li>
                <li><strong>Hitori</strong> - Eliminación y deducción</li>
                <li><strong>Nurikabe</strong> - Pensamiento espacial</li>
                <li><strong>Torres</strong> - Perspectiva y razonamiento</li>
                <li><strong>Mastermind</strong> - Deducción y estrategia</li>
                <li>...y 12 juegos más</li>
              </ul>
            </section>

            <section className="pt-6 border-t border-gray-700">
              <p className="text-center text-gray-400 text-sm">
                Neureka es un proyecto independiente creado con pasión por el entrenamiento cognitivo
                y el bienestar mental.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
